// SubscribedContext.js
import SubscribeModal from "@/components/SubscribeModal";
import { createContext, useState, useEffect } from "react";
import { useSubscriptions } from "@/services/hooks";
import { currentUser } from "@/App";
import { fetchLocation } from "@/services/api";

export const SubscribedContext = createContext();

const checkIsSubscribed = (artistKey) => {
  // or if the currentUser.key == artistKey
  const { data: subscriptions } = useSubscriptions();
  return (
    subscriptions?.some(
      (subscription) => subscription.artist_key === artistKey
    ) || currentUser.key == artistKey
  );
};

export const SubscribedProvider = ({ children, artistKey }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const [country, setCountry] = useState("");
  const [isLimited, setIsLimited] = useState(false);
  const isSubscribed = checkIsSubscribed(artistKey);

  // console.log("isSubscribed", isSubscribed);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  useEffect(() => {
    // fetching is handled at the App level; re-read whenever location resolves
    // so a new user isn't stuck with stale (non-limited) UI until a reload
    const readLocation = () => {
      setCountry(localStorage.getItem("country"));
      setIsLimited(localStorage.getItem("limited") === "true");
    };
    readLocation();
    window.addEventListener("location-updated", readLocation);
    return () => window.removeEventListener("location-updated", readLocation);
  }, []);

  return (
    <SubscribedContext.Provider
      value={{ isSubscribed, handleModalOpen, artistKey, country, isLimited }}
    >
      <SubscribeModal open={modalOpen} setOpen={setModalOpen} />
      {children}
    </SubscribedContext.Provider>
  );
};
